import styled from "styled-components";

export const ConfirmBetModalFooterWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: var(--fd-space-space-3);
  gap: var(--fd-space-space-3);
`;

export const BetConfirmationContainer = styled.div`
  padding: var(--fd-space-space-3);
  flex-direction: column;
  display: flex;
  overflow: auto;
  max-height: calc(85vh - 120px);
`;

export const BetSummarySpecialBetsContainer = styled.div`
  & > div {
    margin-top: var(--fd-space-space-2);
  }
`;

export const AlertMessageContainer = styled.div`
  display: flex;
`;
